import CoreAPI from "../coreAPI";
import Resource from "../../classes/employerDashboard/resource";

export enum ResourceType {
  brochures = "brochures",
  cakes = "cakes",
  demo = "demo",
  postcards = "postcards",
  posters = "posters",
  standees = "standees",
}

export default function APIResource(coreAPI: CoreAPI) {
  return {
    async getResources(types: ResourceType[]) {
      try {
        const data = (
          await Promise.all(
            types.map((type) => {
              return coreAPI.authCall<{ url: string; name: string }[]>({
                endpoint: `/resources?resourceType=${type}`,
              });
            })
          )
        ).flat();
        const resources: Resource[] = [];
        data.forEach((item) => {
          if (item.name.indexOf("-front") > -1) {
            return;
          }
          if (item.name.indexOf("-back") > -1) {
            return;
          }
          const newResource = new Resource(item);

          // It's possible there could be a front and back image
          const backImage = data.find((resource) => resource.name === `${item.name}-back`);
          if (backImage) {
            newResource.backUrl = backImage.url;
          }
          const frontImage = data.find((resource) => resource.name === `${item.name}-front`);
          if (frontImage) {
            newResource.frontUrl = frontImage.url;
          }

          resources.push(newResource);
        });
        return resources;
      } catch (e) {
        return [];
      }
    },
  };
}
